export const defaultSelectedHallazgo = () => {
    return {
        id_empresa: '',
        id_lista_chequeo: '',
        id_tipo_seguimiento: [],
    }
}

export const defaultItem = () => {
    return {
        id: null,
        id_hallazgo: null,
        cumple: null,
        id_empresa: null,
        legislacion: null,
        observaciones: null,
        opciones_mejora: null,
        ubicacion: null,
        code: null,
        monitoring_type: null,
        monitoring_type_id: null,
    }
}

export default {
    selectedHallazgo: defaultSelectedHallazgo(),
    hallazgoArr: [],
    accion: 'Crear',
    id_empresa: '',
    listaChequeo: [],
    listaTipoSeguimientos: [],
    id_lista_chequeo: "",
    items: [],
    arrImage: [],
    error: false,
    hallazgos: [],
    graficaGeneral: [],
    graficaTipoSeg: [],
    datoGrafica1: [],
    datoGrafica2: [],
    bases_areas: [],
    basesAreas: [],
    esEmpresa: false,
    esAdmin: false,
    verEmpresa: true,
    imagenSelecc:"",

    filtro_graficas: {
        id_empresa: '',
        id_lista_chequeo: '',
        id_tipo_seguimiento: ''
    },

    filtro: {
        id_empresa: '',
        page: 1,
        perPage: 10,
        sortBy: 'id_tipo_seguimiento',
        sort: 'DESC',
    },
    filtroImagen: {
        id_empresa: '',
        id_lista_chequeo: '',
        id_item: '',
    },

    plan_accion: [],

    datos_accion: {
        id: '',
        responsable: '',
        fecha_cierre_visita: '',
        fecha_inicio_visita: ''
    },

    imagenPlanAccion: [],

    findingModal: {
        show: false
    },
    item: defaultItem()
}
